import React, { useState } from 'react';
import { CardBody, NavItem, TabContent, TabPane, InputGroup, Card } from 'reactstrap';
import { Link, NavLink } from 'react-router-dom';
import Flatpickr from 'react-flatpickr';
import { ISelector } from '../iComponents/iSelector/iSelector';
import '../../Common/ListItems/listItems.scss';
import moment from 'moment';
import { Collapse } from 'reactstrap';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

interface File {
    name: string;
    type: string;
    namekey: string;
    options?: any;
    readOnly?: boolean;
    onClickButton?: any;
}

interface Item {
    title: string;
    description: string;
    icon: any;
    files?: File[];
    node?: React.ReactNode;
}

interface ComponentProps {
    items: Item[];
}

const FormSteps = ({ items, changeForm, form, finishForm }: ComponentProps & { changeForm: Function } & { form: any } & { finishForm: Function }) => {
    const valuesSizeRolesPagination = [10, 20, 30, 40, 50, 100];
    const [activeTab, setactiveTab] = useState(1);
    const [paginationRoles, setPaginationRoles] = useState<any>({
        sizePerPage: valuesSizeRolesPagination[0],
        page: 1,
    });

    const [selectedItem, setSelectedItem] = useState("");

    const initialArrayTableEntities = [
        {
            text: 'Name',
            dataField: 'name',
            formatter: (cellContent: any, entity: any) => <>{entity.name}</>,
            hidden: false,
        },
    ];

    const iconItem = (id:any) => {
        return id == selectedItem ? <KeyboardArrowRightIcon /> : <KeyboardArrowDownIcon />;
    };

    function toggleTab(tab: any) {
        if (activeTab !== tab) {
            if (tab >= 1 && tab <= items.length + 1) {
                setactiveTab(tab);
            }
        }
    }

    const handlePaginationRolesChange = (newState: any) => {
        setPaginationRoles(newState);
    };

    const renderDate = (nameKey: string, value: string) => (
        <InputGroup>
            <Flatpickr
                value={new Date(value)}
                className="form-control"
                placeholder="mm-dd-yyyy"
                itemKey={nameKey}
                options={{
                    altInput: true,
                    altFormat: 'F j, Y',
                    dateFormat: 'Y-m-d',
                    minDate: 'today',
                }}
                onChange={(date: any) => {
                    const formattedDate = moment(date[0]).format();
                    changeForm(nameKey, formattedDate);
                }}
            />
        </InputGroup>
    );

    const renderSelect = (title: string, nameKey: any, list: any,showButton?:any) => {
        return (
            <ISelector
                onClickButton={showButton ? showButton:null}
                formControl={true}
                title={title}
                nameSelector={form[nameKey]}
                valuesSizePagination={valuesSizeRolesPagination}
                dataSelector={list}
                initialArrayTable={initialArrayTableEntities}
                handlePaginationChange={handlePaginationRolesChange}
                setSelectedRow={(titulo, e) => {
                    console.log(e, 'cambio en la fila', titulo, 'namekey');
                    changeForm(nameKey, e.name, e);
                }}
                // onChangeHandler={(e) => changeForm(nameKey, e.target.value)}
            />
        );
    };


    const moreInformationItem = (id:any) => {
        if(selectedItem == id){
            setSelectedItem("")
        }else{
            setSelectedItem(id)
        }
    };



    const renderSummarySection = (section: any) => {
        return (
            <Card key={`${section.title}_${section.descripcion}_summarySection`} className='container_summarySection'>
                <div className="text-center mb-4">
                    <h5>{section.title}</h5>
                </div>

                <div className='container_items_summary'>
                    {section.files ?
                    section.files.map((file: any, indexf: any) => {
                        return (
                                <div key={`${file.name}_${indexf + 1}_Summary_${indexf}`}  className="">
                                    <label htmlFor="basicpill-firstname-input" className="form-label">
                                        {file.name}
                                    </label>
                                    <input readOnly type={'text'} className="form-control" value={form[file.namekey]} />
                                </div>
                        );
                    }):form.items && form.items.length > 0 ? (
                        form.items.map((item: any, index: any) => {
                            return (
                                <div key={`${item.CLGUID}-${index + 1}-summary`}>
                                    <Card onClick={()=>{moreInformationItem(item.CLGUID)}} className="itemMap_Summary">
                                        <div className='d-flex'>
                                            {iconItem(item.CLGUID)}
                                            <div className='justify-content-start'>
                                                <p className='m-0'>{item.CLPartNumber || item.CLDescription}</p>
                                                <p className='m-0'><b>Pieces:</b> {item.pieces}</p> 
                                            </div>
                                        </div>

                                            <Collapse isOpen={selectedItem == item.CLGUID}>
                                                <div style={{marginLeft:"24px"}} className='w-full'>
                                                    <p className='m-0'><b>PackageName:</b> {item.CLPackageName || "-"}</p>
                                                    <p className='m-0'><b>Description:</b> {item.CLDescription || "-"}</p>
                                                </div>
                                            </Collapse>
                                    </Card>
                                </div>
                            );
                        })
                    ) : (
                        <p className='text-center mb-4'>0 items added</p>
                    )}
                </div>
            </Card>
        );
    };

    return (
        <CardBody>
            <div id="basic-pills-wizard" className="twitter-bs-wizard">
                <ul className="twitter-bs-wizard-nav nav nav-pills nav-justified">
                    {items.map((step, index) => {
                        return (
                            <NavItem key={`${step.title}_${index + 1}`}>
                                <NavLink
                                    to="#"
                                    className={activeTab === index + 1 ? 'nav-link' : ''}
                                    onClick={() => {
                                        setactiveTab(index + 1);
                                    }}
                                >
                                    <div className="step-icon" data-bs-toggle="tooltip" data-bs-placement="top" title="Seller Details">
                                        <i className={step.icon}></i>
                                    </div>
                                </NavLink>
                            </NavItem>
                        );
                    })}

                    <NavItem>
                        <NavLink
                            to="#"
                            className={activeTab === items.length + 1 ? 'nav-link' : ''}
                            onClick={() => {
                                setactiveTab(items.length + 1);
                            }}
                        >
                            <div className="step-icon" data-bs-toggle="tooltip" data-bs-placement="top" title="Seller Details">
                                <i className="bx bx-list-ul"></i>
                            </div>
                        </NavLink>
                    </NavItem>
                </ul>

                <TabContent className="twitter-bs-wizard-tab-content" activeTab={activeTab}>
                    {items.map((step, index) => {
                        return (
                            <TabPane key={`${step.title}_${index + 1}_content`} tabId={index + 1}>
                                <div className="text-center mb-4">
                                    <h5>{step.title}</h5>
                                    <p className="card-title-desc">{step.description}</p>
                                </div>
                                {step.files ? (
                                    <form className="row">
                                        {step.files.map((file, indexf) => {
                                            return (
                                                <div key={`${file.name}_${indexf + 1}_files`} className="col-lg-6">
                                                    <div className="mb-3">
                                                        <label htmlFor="basicpill-firstname-input" className="form-label">
                                                            {file.name}
                                                        </label>
                                                        {file.type == 'date' ? (
                                                            renderDate(file.namekey, form[file.namekey])
                                                        ) : file.type == 'select' ? (
                                                            renderSelect(file.name, file.namekey, file.options,file.onClickButton ? file.onClickButton:null)
                                                        ) : (
                                                            <input
                                                                readOnly={file.readOnly ? true : false}
                                                                onChange={(e) => {
                                                                    changeForm(file.namekey, e.target.value);
                                                                }}
                                                                type={file.type}
                                                                className="form-control"
                                                                value={form[file.namekey]}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </form>
                                ) : (
                                    <div>{step.node && step.node}</div>
                                )}
                            </TabPane>
                        );
                    })}
                    {/* Summary  */}
                    <TabPane tabId={items.length + 1}>
                        <div className="text-center mb-4">
                            <h5>Summary</h5>
                            <p className="card-title-desc">Summary of all the information provided for the creation of the Cargo Release</p>
                        </div>
                        <div className="container_items_summary">
                            {items.map((item: any, index) => {
                                return (
                                    <>
                                        {renderSummarySection(item)}
                                    </>
                                );
                            })}
                        </div>
                    </TabPane>
                </TabContent>
                <ul className="pager wizard twitter-bs-wizard-pager-link">
                    <li className={activeTab === 1 ? 'previous disabled' : 'previous'}>
                        <Link
                            to="#"
                            className={activeTab === 1 ? 'btn btn-primary disabled' : 'btn btn-primary'}
                            onClick={() => {
                                toggleTab(activeTab - 1);
                            }}
                        >
                            <i className="bx bx-chevron-left me-1"></i> Previous
                        </Link>
                    </li>

                    {activeTab <= items.length ? (
                        <li className={'next'}>
                            <Link
                                to="#"
                                className="btn btn-primary"
                                onClick={() => {
                                    toggleTab(activeTab + 1);
                                }}
                            >
                                Next <i className="bx bx-chevron-right ms-1"></i>
                            </Link>
                        </li>
                    ) : null}

                    {activeTab == items.length + 1 ? (
                        <li className={'next'}>
                            <Link
                                to="#"
                                className="btn btn-primary"
                                onClick={() => {
                                    finishForm();
                                }}
                            >
                                Create <i className="bx bx-chevron-right ms-1"></i>
                            </Link>
                        </li>
                    ) : null}
                </ul>
            </div>
        </CardBody>
    );
};

export default FormSteps;
